'use strict';

angular.module('licensure.helpers').factory('File', ['$rootScope', 'LocalDatabase', function ($rootScope, LocalDatabase) {

    var
        fileId = '00000000-0000-0000-000000000000',

        refTable = '',

        refID = '00000000-0000-0000-000000000000',

        getAjaxURL = function (service, method) {
            return $rootScope.internalUrlRoot +
                   'Appraisal/controller.cfm?method=' +
                   service + '.' +
                   method;
        },
        getAjaxURLJSON = function (service, method) {
            return getAjaxURL(service, method) +
                   '&returnformat=json';
        },
        // TODO: helper service
        generateUUID = function () {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
            return uuid;
        },
        dataURItoBlob = function (dataURI) {

            var byteString,
                mimestring;

            if (dataURI.split(',')[0].indexOf('base64') !== -1) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = decodeURI(dataURI.split(',')[1]);
            }

            mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0];

            var content = [];

            for (var i = 0; i < byteString.length; i++) {
                content[i] = byteString.charCodeAt(i);
            }

            return new Blob([new Uint8Array(content)], { type: mimestring });
        },
        getFileContent = function (file_id) {

            var d = $.Deferred();

            $.ajax({
                type: 'GET',
                url: 'inspections/file/getFileContent',
                data: {
                    'file_id': file_id
                },
                dataType: 'JSON',
                cache: false,
                success: function (data) {
                    d.resolve(data);
                },
                error: function (e) {
                    d.reject(e);
                }
            });

            return d.promise();

        },
        getFileContentOffline = function (file_id) {
            var d = $.Deferred();

            Database.get('file', file_id).then(function (data) {
                d.resolve(data);
            })

            return d.promise();
        },
        getFileUrlByID = function (fileID, offline) {

            var d = $.Deferred();

            if (offline) {
                Database.getFileUrlByID(fileID).then(function (url) {
                    d.resolve(url);
                }).fail(function (e) {
                    d.reject(e);
                });
            } else {
                d.resolve(getAjaxURL('fileController', 'downloadFile') + '&fileID=' + fileID);
            }

            return d.promise();

        },
        saveImageData = function (param) {
            //refId, fileId, refTable
            var d = $.Deferred();

            $.ajax({
                type: 'POST',
                data: param,
                dataType: 'JSON',
                url: param.url,
                cache: false,
                error: function (e) {
                    d.reject(e);
                },
                success: function (result) {
                    d.resolve(result);
                }
            });

            return d.promise();
        },
        bulkUploadPhoto = function (file, appraisalID, itemID) {
            var fd = new FormData(),
                d = $.Deferred();

            fd.append('upload', file, file.name);
            fd.append('name', file.name);
            fd.append('appraisalID', appraisalID);
            fd.append('field_name', 'upload');
            if (itemID != '') {
                fd.append('itemID', itemID);
            }

            $.ajax({
                url: $rootScope.internalUrlRoot + 'Appraisal/controller.cfm?method=AppraisalService.saveBulkPhoto&returnformat=json',
                type: 'POST',
                data: fd,
                contentType: false,
                cache: false,
                processData: false,
                error: function (e) {
                    d.reject(e, file);
                },
                success: function (data) {
                    d.resolve(data, file);
                }
            });

            return d.promise();
        },
        indexImages = function (appraisalKey, itemID, itemMediaIds, inspectionPointID, recommendedPhotoID, existingPhotoCount) {
            var args = { appraisalKey: appraisalKey, itemID: itemID, itemMediaIds: itemMediaIds, inspectionPointID: inspectionPointID, recommendedPhotoID: recommendedPhotoID, existingPhotoCount: existingPhotoCount };

            var d = $.Deferred();

            $.ajax({
                type: 'POST',
                data: args,
                url: $rootScope.internalUrlRoot + 'Appraisal/controller.cfm?method=AppraisalService.indexPhotos&returnformat=json',
                async: false,
                cache: false,
                error: function (e) {
                    d.reject(e);
                },
                success: function (result) {
                    d.resolve(result);
                }
            });

            return d.promise();

        };

    return {
        setReference: function (id, table, imgData, fileID) {
            refTable = table;
            refID = id;
            $rootScope.$broadcast("referenceUpdated", refID, refTable, imgData, fileID);
        },
        setFileID: function (ID, internal) {
            fileId = ID;
            $rootScope.$broadcast("file_updated_" + refID, fileId, internal);
        },
        saveFile: function (param, internal, addArray) {
            var d = $.Deferred();

            if (internal !== 'false') {
                var fd = new FormData();

                if (param.file_id !== undefined && param.file_id !== null) {
                    fd.append('file_id', param.file_id);
                }
                if (param.description !== undefined && param.description !== null) {
                    fd.append('description', param.description);
                }
                if (param.document_type_id !== undefined && param.document_type_id !== null) {
                    fd.append('document_type_id', param.document_type_id);
                }
                fd.append('name', param.name);
                fd.append('file_name', param.file_name);
                fd.append('file_size', param.file_size);
                fd.append('file_content', param.file_content);
                fd.append('file_type', param.file_type);
                fd.append('ref_id', param.ref_id);
                fd.append('ref_table', param.ref_table);

                if (param.ref_field === "Value") {
                    fd.append('ref_field', param.ref_field);
                }

                $.ajax({
                    type: 'POST',
                    data: fd,
                    url: 'inspections/file/saveFile',
                    contentType: false,
                    processData: false,
                    cache: false,
                    error: function (e) {
                        d.reject(e);
                    },
                    success: function (data) {
                        d.resolve(data);
                    }
                });
            }
            else {
                if (param.file_id === undefined || param.file_id === null || param.file_id === '') {
                    param.file_id = generateUUID();
                }

                param.original = false;
                addArray.push(param);
                d.resolve({ 'success': true, 'file_id': param.file_id });
            }

            return d.promise();
        },
        deletePhoto: function (data, internal, deleteArray, addArray) {
            var d = $.Deferred();

            if (internal !== 'false') {
                $.ajax({
                    type: 'POST',
                    url: 'inspections/file/deletePhoto',
                    data: {
                        file_id: data.file_id,
                        ref_id: data.ref_id,
                        ref_table: data.ref_table
                    },
                    dataType: 'JSON',
                    success: function (data) {
                        d.resolve(data);
                    },
                    error: function (e) {
                        d.reject(e);
                    }
                });
            }
            else {
                var found = false;
                var index;

                addArray.forEach(function (photo, i) {
                    if (photo.file_id == data.file_id) {
                        found = true;
                        index = i;
                    }
                })

                if (found) {
                    addArray.splice(index, 1);
                }
                else {
                    deleteArray.push(data.file_id);
                }

                d.resolve({ 'success': true });
            }

            return d.promise();
        },

        getFileUrlByID: getFileUrlByID,

        getFileContent: getFileContent,

        getFileContentOffline: getFileContentOffline,

        dataURItoBlob: dataURItoBlob

    };

}]);